import React, { useState } from 'react';
import { Box, Typography, Grid, FormControlLabel, Checkbox } from '@mui/material';
import { FormComponentProps, DeductionsData } from '../../types/forms';

const deductionOptions = [
  { label: 'Medical expenses over 7.5% of income', key: 'medical', checked: true },
  { label: 'Mortgage Interest (1098)', key: 'mortgage', checked: true },
  { label: 'Property Taxes', key: 'property', checked: true },
  { label: 'Student Loan Interest (1098-E)', key: 'studentLoan', checked: true },
  { label: 'Education Expenses (1098-T)', key: 'education', checked: true },
  { label: 'Childcare Costs', key: 'childcare', checked: true },
  { label: 'Charitable Donations', key: 'charitable', checked: true },
  { label: 'Retirement Contributions (IRA, 401k)', key: 'retirement', checked: false },
  { label: 'Health Savings Account (HSA) Contributions', key: 'hsa', checked: true },
  { label: 'Energy-Efficient Home Improvements', key: 'energy', checked: true },
];

const Deductions: React.FC<FormComponentProps<DeductionsData>> = ({ data, onNext }) => {
  const [checkedState, setCheckedState] = useState<Record<string, boolean>>(() => {
    const initial: Record<string, boolean> = {};
    if (data?.deductions) {
      data.deductions.forEach(deduction => {
        initial[deduction.type] = true;
      });
    } else {
      deductionOptions.forEach(option => {
        initial[option.key] = option.checked;
      });
    }
    return initial;
  });

  const handleChange = (key: string) => {
    const newState = { ...checkedState, [key]: !checkedState[key] };
    setCheckedState(newState);
    onNext({
      deductions: Object.entries(newState)
        .filter(([_, isChecked]) => isChecked)
        .map(([type]) => ({
          type,
          amount: 0,
          description: deductionOptions.find(opt => opt.key === type)?.label || ''
        }))
    });
  };

  return (
    <Box>
      <Typography variant="h3" gutterBottom sx={{ fontWeight: 400 }}>
        Deductions & Credits
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph sx={{ fontWeight: 400 }}>
        Help us identify potential deductions and credits to maximize your tax savings.
      </Typography>
      <Grid container spacing={4}>
        {deductionOptions.map((option) => (
          <Grid item xs={12} sm={6} key={option.key}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedState[option.key]}
                  onChange={() => handleChange(option.key)}
                  color="primary"
                />
              }
              label={<Typography variant="h6" sx={{ fontWeight: 400 }}>{option.label}</Typography>}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Deductions; 